import { useState } from "react";
import SectionHeading from "./SectionHeading";

type Reply = { name: string; char: string; tone: string; text: string; likes: string; tag?: string };

type Thread = {
  id: number;
  author: string;
  char: string;
  topic: string;
  question: string;
  replies: Reply[];
};

const THREADS: Thread[] = [
  {
    id: 1,
    author: "一只爱吃瓜的猫",
    char: "猫",
    topic: "影视 · 年度片单",
    question: "有没有一部电影，让你看完后在评论区疯狂安利了很久？我先来，《夏日的西瓜与蝉鸣》真的后劲太大。",
    replies: [
      { name: "深夜档选手", char: "夜", tone: "bg-primary-100", text: "同款！结尾那段我三刷都哭，导演太会了。", likes: "1.2万", tag: "高赞" },
      { name: "不喝奶茶会死", char: "奶", tone: "bg-accent-100", text: "那我必须提名那部公路片，看完直接订了张去新疆的车票。", likes: "8653" },
      { name: "精神四川人", char: "辣", tone: "bg-secondary-100", text: "评论区人均文豪，把我都说心动了，今晚就补。", likes: "4310" },
    ],
  },
  {
    id: 2,
    author: "今天也要元气满满",
    char: "元",
    topic: "社会 · 生活记录",
    question: "打工人被治愈的瞬间：加班到很晚，回家路上看到街边卖西瓜的大叔冲我笑。那一刻我突然觉得生活也没那么糟。",
    replies: [
      { name: "莫生气", char: "平", tone: "bg-accent-100", text: "太真实了，这种微小的善意最戳人。", likes: "2.3万", tag: "高赞" },
      { name: "人间清醒", char: "醒", tone: "bg-primary-100", text: "同感，成年人真的会被一点温柔瞬间治愈。", likes: "1.6万" },
      { name: "晚风与瓜", char: "风", tone: "bg-secondary-100", text: "抱抱，愿每一个善良的人都有人温柔以待。", likes: "9382" },
    ],
  },
  {
    id: 3,
    author: "键盘侠克星",
    char: "侠",
    topic: "科技 · AI 实测",
    question: "用 AI 把全网神评改编成悬疑小说，结果评论区的画风彻底失控了，还有人要给 AI 写推荐信。",
    replies: [
      { name: "科技少女", char: "技", tone: "bg-secondary-100", text: "哈哈哈哈哈 AI：我只是想当个段子手，你们非要我当编剧。", likes: "1.9万" },
      { name: "老实人", char: "实", tone: "bg-primary-100", text: "重点不是小说，是评论区这群人能把任何事聊成连续剧。", likes: "7610" },
      { name: "吃瓜专业户", char: "瓜", tone: "bg-accent-100", text: "这就是我喜欢吃瓜的原因，永远不知道下一秒笑点在哪。", likes: "5233" },
    ],
  },
];

export default function Voices() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  return (
    <section id="discussion" className="bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="评论区热议"
          title="围观群众的"
          accent="神评论"
          desc="每一条评论都是真实网友的发言，高赞神评背后藏着最朴素的共鸣。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 items-start">
          {THREADS.map((thread) => (
            <article
              key={thread.id}
              className="flex flex-col rounded-2xl bg-background-50 p-5 ring-1 ring-background-200/70"
            >
              <div className="flex items-start gap-3">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100 text-lg text-primary-700 font-semibold">
                  {thread.char}
                </span>
                <div>
                  <h3 className="text-[15px] font-semibold text-foreground-900">{thread.author}</h3>
                  <p className="text-xs text-foreground-500">{thread.topic}</p>
                </div>
              </div>

              <p className="mt-4 text-sm leading-relaxed text-foreground-700">{thread.question}</p>

              <div className="mt-4 flex flex-col gap-3 border-t border-background-200 pt-4">
                {thread.replies.map((reply) => {
                  const key = `${thread.id}-${reply.name}`;
                  return (
                    <div key={reply.name} className="rounded-xl bg-background-100/80 p-3">
                      <div className="flex items-center gap-2">
                        <span
                          className={`flex h-6 w-6 items-center justify-center rounded-full ${reply.tone} text-xs text-foreground-700`}
                        >
                          {reply.char}
                        </span>
                        <span className="text-xs text-foreground-600">{reply.name}</span>
                        {reply.tag && (
                          <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-800">
                            {reply.tag}
                          </span>
                        )}
                      </div>
                      <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-700">
                        {reply.text}
                      </p>
                      <button
                        type="button"
                        aria-label="点赞这条回复"
                        onClick={() => setLiked((p) => ({ ...p, [key]: !p[key] }))}
                        className={`mt-2 inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs transition-colors ${
                          liked[key]
                            ? "bg-primary-100 text-primary-700"
                            : "text-foreground-500 hover:bg-background-50 hover:text-primary-600"
                        }`}
                      >
                        <i className={liked[key] ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
                        {liked[key] ? reply.likes : "赞一个"}
                      </button>
                    </div>
                  );
                })}
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-center text-xs text-foreground-500">
          言论均由网友发布，仅代表个人观点。请理性发言，共同维护文明的吃瓜氛围。
        </p>
      </div>
    </section>
  );
}